import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setAuthorization from '../utils/helpers/setAuthorization'
import { API_BASE_URL } from '../constants/api'
import { CohortsModel } from '@models'

const cohortsRepository = createApi({
	reducerPath: 'cohortsRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['Cohorts', 'Matriculate', 'ProgressCheck'],
	endpoints: (builder) => ({
		getCohorts: builder.query<
			{
				courses: Array<{
					id: number
					name: string
					curso_id: number
					progress: string
					status: string
					capa_card: string
					'type-course': string
					categoria: string
					produto: string
				}>
			},
			{ userId: number }
		>({
			query: ({ userId }) => ({
				url: `/v1/cohorts/${userId}/turmas`,
				method: 'GET',
			}),
			providesTags: ['Cohorts'],
		}),
		getProgressCheck: builder.query<
			{
				progressChecks: Array<{
					id: number
					turma_id: number
					data_inicio: string
					data_final: string
					duracao_dias: number
					data_ultimo_envio: string
					submitted: Array<number>
					total_tentativas: number
					isAvailable: boolean
					nome: string
					link: string
				}>
				show_modal_progress_check: boolean
			},
			{ cohortId: number }
		>({
			query: ({ cohortId }) => ({
				url: `/v1/cohorts/${cohortId}/progress-checks-by-user`,
				method: 'GET',
			}),
			providesTags: ['ProgressCheck'],
		}),
		getMatriculate: builder.query<
			CohortsModel.MatriculateList,
			{ userId: number }
		>({
			query: ({ userId }) => ({
				url: `/v1/cohorts/${userId}/cursos-disponiveis`,
				method: 'GET',
			}),
			providesTags: ['Matriculate'],
		}),
		getMatriculateCompleted: builder.query<
			{
				complete_courses: Array<{
					id: number
					name: string
					'type-course': string
					teacher: string
					company: string
				}>
			},
			{ userId: number }
		>({
			query: ({ userId }) => ({
				url: `/v1/cohorts/${userId}/cursos-completos`,
				method: 'GET',
			}),
			providesTags: ['Matriculate'],
		}),
		matriculateRecorded: builder.mutation<
			{ message: string },
			{ cohortId: number; userId: number }
		>({
			query: ({ cohortId, userId }) => ({
				url: `/v1/cohorts/${cohortId}/students`,
				method: 'POST',
				body: { studentId: userId },
			}),
			invalidatesTags: ['Matriculate', 'Cohorts'],
		}),
		saveAttempt: builder.mutation<
			void,
			{
				progress_check_id: number
				data_tentativa: string
				nota: number
				user_id?: number
			}
		>({
			query: ({ user_id, ...body }) => ({
				url: `/v1/cohorts/${user_id}/attempts`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['ProgressCheck'],
		}),
	}),
})

export default cohortsRepository
